var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartovericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00879283 18.4987C0.00879283 15.965 0.0275687 13.4312 0.000258341 10.8975C-0.0133968 9.62473 0.517448 8.73666 1.644 8.11451C6.25092 5.57239 10.8476 3.01354 15.4391 0.444662C16.4991 -0.149057 17.5045 -0.147384 18.5645 0.444662C23.156 3.01354 27.7527 5.57239 32.3596 8.11451C33.4862 8.73666 34.0051 9.62808 34 10.9008C33.9795 15.9683 33.9795 21.0342 34 26.1017C34.0051 27.3744 33.4828 28.2642 32.3562 28.8863C27.751 31.4301 23.1526 33.9873 18.5611 36.5562C17.5011 37.1499 16.494 37.1465 15.4357 36.5545C10.8442 33.9856 6.24751 31.4268 1.64059 28.8846C0.514035 28.2625 -0.0133968 27.3728 0.000258341 26.1C0.0275687 23.5646 0.00879283 21.0308 0.00879283 18.4987Z",
    fill: "url(#paint0_linear_1087_128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0338 13.4373C17.387 13.7471 17.7655 14.0092 18.0935 14.3428C18.5729 14.8194 18.5224 15.4628 18.0682 15.8917C17.6141 16.3206 16.9329 16.3445 16.4283 15.8917C15.091 14.6764 13.8043 13.4135 12.3914 12.0791C12.8455 11.6978 13.2744 11.3404 13.6781 10.9353C14.5612 10.1012 15.419 9.26722 16.3021 8.4332C16.8824 7.88513 17.5889 7.8613 18.0935 8.33789C18.5981 8.81447 18.5729 9.48168 17.9926 10.0298C17.6898 10.3157 17.3618 10.6017 16.9833 10.9591C17.5889 11.0067 18.0682 11.0544 18.5224 11.1259C23.1144 11.8884 26.1925 15.6058 25.9906 20.1095C25.7888 24.1843 22.2061 27.6157 17.7402 27.9731C12.6184 28.3544 8.17788 24.637 8.00126 19.7997C7.97603 18.9895 8.32926 18.4891 9.03571 18.3938C9.79263 18.2985 10.3477 18.7512 10.3729 19.5376C10.4486 21.158 11.0289 22.5877 12.2148 23.7792C14.208 25.7808 17.3366 26.3051 19.9353 25.1136C22.4836 23.9221 24.0479 21.2056 23.5937 18.6559C23.0891 15.8202 20.8436 13.6756 17.9421 13.2943C17.6898 13.2705 17.4123 13.2705 17.1347 13.2467C17.1095 13.3182 17.0843 13.3897 17.0338 13.4373Z",
    fill: "#313131"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1087_128",
    x1: 33.2681,
    y1: 30.4859,
    x2: 0.415581,
    y2: 8.92998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128199,
    stopColor: "#FFDBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942149,
    stopColor: "#FFF4D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartovericon);
export default __webpack_public_path__ + "static/media/startovericon.ee92df54f947bcaf544df2d161e031b8.svg";
export { ForwardRef as ReactComponent };